import React, { PropTypes } from 'react';

export class SettingsWrapper extends React.Component {

  static propTypes = {
    children: PropTypes.element
  };

  render () {
    return (
      <div className='settings'>
        {this.props.children}
      </div>
    );
  }
}

export default SettingsWrapper;



/** WEBPACK FOOTER **
 ** ./src/views/settings/settings-wrapper.js
 **/